import React, { useState, useEffect, useRef } from "react";
import { getAllMentors } from "../utils";

function FeaturedMentors() {
  const [mentors, setMentors] = useState([]);
  const ref = useRef(null);

  const scroll = (scrollOffset) => {
    ref.current.scrollLeft += scrollOffset;
  };

  useEffect(() => {
    if (sessionStorage.getItem("mentorData") == null) {
      getAllMentors()
        .then((data) => {
          setMentors(data.sort((a, b) => b.createdAt - a.createdAt));
          sessionStorage.setItem("mentorData", JSON.stringify(data));
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      setMentors(JSON.parse(sessionStorage.getItem("mentorData")));
    }
  }, []);

  return (
    <div>
      <div className="container px-5 py-8 mx-auto hide-scroll-bar">
        <div className="flex flex-wrap w-full mb-8 items-center justify-between ">
          <div className="lg:w-1/2 w-full mb-6 lg:mb-0">
            <h1 className="sm:text-3xl text-2xl font-bold title-font mb-2 text-gray-900">
              Learn from the world's best
            </h1>
            {/* <div className="h-1 w-40 bg-blue-500 rounded"></div> */}
          </div>
          <div className="hidden md:flex items-center">
            <a href="/mentors">
              <button className="border-2 rounded-md border-gray-500 p-2 text-sm font-semibold hover:bg-black hover:text-white">
                Explore all
              </button>
            </a>
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-8 w-8 ml-4 border-2 border-black rounded-full p-1"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                onClick={() => scroll(-450)}
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </div>
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-8 w-8 ml-4 border-2 border-black rounded-full p-1"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                onClick={() => scroll(450)}
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>
          </div>
        </div>

        <div
          className="flex overflow-x-scroll no-scrollbar space-x-4 overflow-y-hidden"
          ref={ref}
        >
          {mentors.map((mentorData) => (
            <div key={`${mentorData.username}`} className="flex flex-row -m-4">
              <div className="p-4 sm: w-80 h-full">
                <a
                  href={`/mentor/${mentorData.username}`}
                  className="block object-cover rounded-lg p-5 transform transition-all duration-300 scale-100 hover:scale-95 h-full border border-gray-200"
                  style={{
                    backgroundImage: `url(${mentorData.profilePic})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    boxShadow: "inset 0 -10em 5em -5em #000000",
                    transform: "rotate3d(0, 0, 1, 20deg) scale3d(1, 0.6, 1}",
                  }}
                >
                  <div className="h-64 w-64"></div>
                  <h2 className="text-white text-2xl font-bold leading-tight mb-1 pr-5 bg-blend-darken">
                    {mentorData.name}
                  </h2>
                  <div className="text-sm text-white font-bold mb-2 ">
                    {mentorData.company}
                  </div>
                  <div className="flex w-80 sm:w-full items-center text-sm text-white font-medium bottom-end truncate">
                    <div className="flex-1 flex items-center">
                      <div className="flex ">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                          />
                        </svg>
                        <h1 className="ml-2 text-sm ">
                          Ask me about{" "}
                          <span className="font-medium">
                            {mentorData.interest
                              ? mentorData.interest.join(", ")
                              : ""}
                          </span>
                        </h1>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FeaturedMentors;
